<h2 mat-dialog-title style="color: #0061A2">
  {{title}}
</h2>
<form [formGroup]="newContact" fxFlexLayout="column" style="width: 100%; margin: 20px 0px;" (ngSubmit)="onConfirm()" autocomplete="off" autocomplete="off">
  <div mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 99%;">
      <mat-label>Nombre Contacto</mat-label>
      <input matInput placeholder="Nombre Contacto" formControlName="name">
      <mat-error id="requiredNameError" *ngIf="newContact.controls['name'].hasError('required')">
        El nombre es
        <strong>requerido</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 99%;">
      <mat-label>Cargo</mat-label>
      <input matInput placeholder="Cargo" formControlName="charge">
      <mat-error id="requiredChargeError" *ngIf="newContact.controls['charge'].hasError('required')">
        El cargo es
        <strong>requerido</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 99%;">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" formControlName="email" type='email'>
      <mat-error id="invalidEmailError" *ngIf="newContact.controls['email'].hasError('email')">
        Por favor ingresar un correo válido
      </mat-error>
      <mat-error id="requiredEmailError" *ngIf="newContact.controls['email'].hasError('required')">
        El correo es
        <strong>requerido</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 99%;">
      <mat-label>Teléfono (Opcional)</mat-label>
      <input matInput placeholder="Ej: +569XXXXXXXX" formControlName="phone" type="tel">
      <mat-error id="requiredTelError" *ngIf="newContact.controls['phone'].hasError('required')">
        El teléfono es
        <strong>requerido</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div mat-dialog-actions fxLayoutAlign="end none">
    <button mat-button type="button" (click)="onDismiss()">Cancelar</button>
    <button mat-raised-button color="primary" type="submit">Guardar</button>
  </div>
</form>